import { ChangeDetectionStrategy, Component, Host } from '@angular/core';
import { BoschUiHeaderRowDefDirective } from '../directives/bosch-ui-header-row-def.directive';
import { BoschUiTableService } from '../bosch-ui-table.service';

@Component({
  selector: 'bosch-ui-table-header-row',
  templateUrl: './bosch-ui-table-header-row.component.html',
  styleUrls: ['./bosch-ui-table-header-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiTableHeaderRowComponent<DataType> {
  public rowDisplayColumns = this.boschUiRowDefDirective.headerRowDisplayColumns;

  constructor(
    public tableService: BoschUiTableService<DataType>,
    @Host() private boschUiRowDefDirective: BoschUiHeaderRowDefDirective<DataType>,
  ) {}
}
